<template>
<div class="ribbon" ref="ribbon">

  <ItemHolder
    class="item"
    :key="item.i1"
    v-for="(item, iK) in items"
    :active="item.active"


    :i1="item.i1"
    :i2="item.i2"
    :top1="item.top1"
    :top2="item.top2"
    :left1="item.left1"
    :left2="item.left2"
    :i1s="item.i1s"
    :i2s="item.i2s"

    :style="getStyle(item, iK)"
    @click="setItemActive(item, iK)"
  />

</div>
</template>

<script>
import ItemHolder from './Items/ItemHolder.vue'
export default {
  props: {
    items: {}
  },
  components: {
    ItemHolder
  },
  data () {
    return {
      adder: 0
    }
  },
  mounted () {
    let ribbon = this.$refs['ribbon']
    let iState = {
      inertia: 1,
      sx: 0,
      sy: 0,
      dx: 0,
      dy: 0
    }

    var touchstartr = (evt) => {
      iState.sx = evt.touches[0].pageX
      iState.sy = evt.touches[0].pageY
    }
    var touchmover = (evt) => {
      iState.dx = evt.touches[0].pageX - iState.sx
      iState.dy = evt.touches[0].pageY - iState.sy

      iState.sx = evt.touches[0].pageX
      iState.sy = evt.touches[0].pageY

      iState.inertia = 1
    }
    var wheelr = (evt) => {
      evt.preventDefault()

      iState.inertia = 1
      iState.dx = evt.deltaY
      iState.dx += -evt.deltaX * 0.5
    }
    ribbon.addEventListener('wheel', wheelr)
    ribbon.addEventListener('touchstart', touchstartr)
    ribbon.addEventListener('touchmove', touchmover)

    var rAF = () => {
      if (iState.inertia >= 0.01) {
        this.adder += iState.dx * iState.inertia
        this.adder -= 0.35
      } else {
        this.adder -= 0.35
      }
      iState.inertia *= 0.97
      window.requestAnimationFrame(rAF)
    }
    window.requestAnimationFrame(rAF)
  },
  methods: {
    setItemActive (item, iK) {
      this.items.forEach((iii) => {
        iii.active = false
      })
      item.active = true
      this.$emit('choose', { item, iK })
    },
    getStyle (item, iK) {
      let count = this.items.length - 1
      // let dynamic = window.innerWidth / count
      let constant = 150
      let x = constant
      let max = count * constant + constant
      // if (dynamic < constant) {
      //   x = constant
      //   max = count * constant
      // }

      let h = iK % 2
      h = h * 10
      h -= 75

      let v = this.adder + max * 100 - constant * 0.75

      let l = ((iK * x) + v) % max
      l = l - 175

      return {
        transform: `translate3d(${l}px, ${h}px, 0.1px)`
      }
    }
  }
}
</script>

<style scoped>
.ribbon{
  overflow: hidden;
  width: 100%;
  max-width: 1500px;
  height: 170px;
  position: relative;
}
.ribbon{
  mask-image: linear-gradient(90deg, transparent 0%, rgba(0, 0, 0, 1.0) 20%, rgba(0, 0, 0, 1.0) 80%, transparent 100%);
}

@media screen and (min-width: 767.77px) {
/* @media screen and (min-width: 1439px) { */
  .ribbon{
    max-width: 770px;
  }
}

/* @media screen and (min-width: 415px) {
} */
</style>



// WEBPACK FOOTER //
// src/components/Pages/KidsWishes/Ribbon.vue